export default __webpack_public_path__ + "static/media/graphic.bdcca982.png";